import React from "react";
import { Grid } from "@material-ui/core";
import { themeObject } from "@theme";

type Props = React.ComponentProps<typeof Grid> & {
  dirty: boolean;
};

export function Grid3(props: Props) {
  const { dirty, ...rest } = props;

  return (
    <Grid
      item
      xs={3}
      {...rest}
      style={{
        backgroundColor: dirty ? themeObject.palette.secondary.background : "transparent",
        ...rest.style
      }}
    />
  );
}
